import { usePermissions } from '@dispatch/shared/hooks';
import { useCurrentUser } from '@dispatch/web/auth';
import { TaskTemplates } from '@dispatch/web/features/task-templates';
import { Outlet } from 'react-router-dom';
import { useGetTemplates } from './UseGetTemplates';

const TaskTemplatesPage = () => {
  const { tenantId } = useCurrentUser();
  const { permissions } = usePermissions();

  const {
    status,
    data: taskTemplates,
    refetch,
  } = useGetTemplates({ tenantId: tenantId || '' });

  return (
    <>
      <TaskTemplates
        rows={taskTemplates?.data}
        status={status}
        permissions={permissions}
      />
      <Outlet context={{ refetchList: refetch }} />
    </>
  );
};

export default TaskTemplatesPage;
